import React from 'react';
import {Grid} from "@material-ui/core";
import {useTranslation} from "react-i18next";


export default function BookingChart ({forecast, channelForecast}) {
    const { t } = useTranslation();
    // Sunucu period/forecastTotal/title alanlarini bos gonderirse Gelismis Panel cokmesin.
    const isMonthly = (channelForecast?.title || "").indexOf("Monthly") !== -1;
    const period = channelForecast?.period || [];
    const forecastTotal = channelForecast?.forecastTotal || {};

    return (
       <Grid container className="d-block channel-forecast">
           <div className="forecast-header">
               { channelForecast?.title }
           </div>
           <Grid className="d-flex channel-forecast-date mb-16">
               <div className="forecast-title" />
               {
                   period.map(data => (
                       <div className="d-flex">
                           {
                               isMonthly ?
                                   data :
                                   <span className="forecast-daily-title">{data.split("-")[2]}</span>
                           }
                       </div>
                   ))
               }
               <div className="d-flex">
                   <span className="forecast-daily-title">{ t('web-offer-total') }</span>
               </div>
           </Grid>
           {
               forecast && forecast.map(data => (
                   <div className="d-flex forecast-item">
                       <span className="forecast-title">{data.title}</span>
                       <div className="channel-forecast-price">
                           {Object.values(data.data || {}).map(price => (
                               <div>{price}</div>
                           ))}
                           <div className="fw-600">{data.total}</div>
                       </div>
                   </div>
               ))
           }

           <Grid className="d-flex channel-forecast-date mt-14">
               <span className="forecast-title">{ t('web-offer-total') }</span>
               {
                   Object.values(forecastTotal).map(data => (
                       <div className="d-flex">
                           {
                               isMonthly ?
                                   <span className="forecast-monthly-title">{data}</span> :
                                   <span className="forecast-daily-title">{data}</span>
                           }
                       </div>
                   ))
               }
               <div className="d-flex">
                   <span className="forecast-daily-title"></span>
               </div>
           </Grid>
       </Grid>
    );
}